import { useOutletContext } from 'react-router-dom';
import type { Room } from '@dataroom/shared';

/** What the room shell hands every room subpage through the router outlet. */
export interface RoomOutletContext {
  roomId: string;
  room: Room;
  /** Open the checklist-source dialog (default / upload / saved / skip). */
  openChecklistSetup: () => void;
}

export function useRoomContext(): RoomOutletContext {
  return useOutletContext<RoomOutletContext>();
}
